import React from 'react';
import {message, Tabs} from 'antd'
import {InputType} from './input-const';
import SettingInput from "./setting-input";
import SettingTextArea from "./setting-textarea";
import SettingRadio from './setting-radio';
import SettingSelect from './setting-select';
import SettingSwitch from './setting-switch';
import SettingDatePicker from './setting-datepicker'
import SettingRangePicker from './setting-rangepicker';
import SettingUploadPicker from './setting-upload'
import SettingTimePicker from './setting-timepicker';
import SettingMultiSelect from './setting-multiSelect';
import SettingNHCascader from './setting-nhcascader';
import SettingDateTimePicker from './setting-datetimepicker';
import SettingInputNumber from './setting-inputNumber';
import SettingMonthPicker from './setting-monthpicker';
import SettingOldUploadPicker from './setting-old-upload'

const TabPane = Tabs.TabPane;

/**
 * 输入控件参数设置页面
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-05 14:56:33
 * Version: 1.0
 * Modify log:
 */
class EditPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      defaultActiveKey: InputType.INPUT, //初始显示输入控件配置页面
      feature: '' //输入控件配置参数
    }
  }

  static defaultProps = {
    initFeature: ''  //初始输入控件配置参数
  };

  //在渲染前调用,可在此最后一次初始化组件状态
  componentWillMount() {
    //将输入控件配置参数设置到状态中
    if (this.props.initFeature) {
      try {
        let initFeature = JSON.parse(this.props.initFeature);
        this.setState({
          defaultActiveKey: initFeature.type ? initFeature.type : InputType.INPUT,
          feature: this.props.initFeature
        });
      } catch (e) {
        console.log(e);
        message.error('解析控件配置参数出错！');
      }
    }
  }

  //React将会在组件实例化的时候调用ref回调和DOM元素，当它销毁的时候调用它和null。
  saveSettingInputRef = (ref) => {
    this.settingInputRef = ref;
    //这里判断是否是初始进来的页面，如果是初始页面，则防止feature被覆盖
    if (ref !== null && (this.state.defaultActiveKey != InputType.INPUT || this.state.feature == '')) {
      //当组件实例化时（这里是当前显示的组件），同步获取其feature
      this.setState({ feature: ref.getFeature() });
    }
  }

  saveSettingTextAreaRef = (ref) => {
    this.settingTextAreaRef = ref;
    if (ref !== null && (this.state.defaultActiveKey != InputType.TEXTAREA || this.state.feature == '')) {
      this.setState({ feature: ref.getFeature() });
    }
  }

  saveSettingRadioRef = (ref) => {
    this.settingRadioRef = ref;
    if (ref !== null && (this.state.defaultActiveKey != InputType.RADIO || this.state.feature == '')) {
      this.setState({ feature: ref.getFeature() });
    }
  }

  saveSettingSelectRef = (ref) => {
    this.settingSelectRef = ref;
    if (ref !== null && (this.state.defaultActiveKey != InputType.SELECT || this.state.feature == '')) {
      this.setState({ feature: ref.getFeature() });
    }
  }

  saveSettingSwitchRef = (ref) => {
    this.settingSwitchRef = ref;
    if (ref !== null && (this.state.defaultActiveKey != InputType.SWITCH || this.state.feature == '')) {
      this.setState({ feature: ref.getFeature() });
    }
  }

  saveSettingDatePickerRef = (ref) => {
    this.settingDatePickerRef = ref;
    if (ref !== null && (this.state.defaultActiveKey != InputType.DATEPICKER || this.state.feature == '')) {
      this.setState({ feature: ref.getFeature() });
    }
  }

  saveSettingRangePickerRef = (ref) => {
    this.settingRangePickerRef = ref;
    if (ref != null && (this.state.defaultActiveKey != InputType.RANGEPICKER || this.state.feature == '')) {
      this.setState({ feature: ref.getFeature() });
    }
  }

  saveSettingUploadRef = (ref) => {
    this.settingUploadRef = ref;
    if (ref !== null && (this.state.defaultActiveKey !== InputType.UPLOAD || this.state.feature == '')) {
      this.setState({ feature: ref.getFeature() })
    }
  }

  saveSettingOldUploadRef = (ref) => {
    this.settingOldUploadRef = ref;
    if (ref !== null && (this.state.defaultActiveKey !== InputType.OLDUPLOAD || this.state.feature == '')) {
      this.setState({ feature: ref.getFeature() })
    }
  }

  saveSettingTimePickerRef = (ref) => {
    this.settingTimePickerRef = ref;
    if (ref !== null && (this.state.defaultActiveKey !== InputType.TIMEPICKER || this.state.feature == '')) {
      this.setState({ feature: ref.getFeature() });
    }
  }

  saveSettingMultiSelectRef = (ref) => {
    this.settingMultiSelectRef = ref;
    if (ref !== null && ( this.state.defaultActiveKey !== InputType.MULTISELECT || this.state.feature == '')) {
      this.setState({feature: ref.getFeature()});
    }
  }
  saveSettingNHCascaderRef = (ref) => {
    this.settingNHCascaderRef = ref;
    if (ref !== null && ( this.state.defaultActiveKey !== InputType.NHCASCADER || this.state.feature == '')) {
      this.setState({feature: ref.getFeature()});
    }
  }
  saveSettingDateTimePickerRef = (ref) => {
    this.settingDateTimePickerRef = ref;
    if (ref !== null && ( this.state.defaultActiveKey !== InputType.DATETIMEPICKER || this.state.feature == '')) {
      this.setState({feature: ref.getFeature()});
    }
  }
  saveSettingInputNumberRef = (ref) => {
    this.settingInputNumberRef = ref;
    if (ref !== null && (this.state.defaultActiveKey !== InputType.INPUTNUMBER || this.state.feature == '' )) {
      this.setState({feature: ref.getFeature()});
    }
  }

    saveSettingMonthPickerRef = (ref) => {
        this.settingMonthPickerRef = ref;
        if (ref !== null && (this.state.defaultActiveKey != InputType.MONTHPICKER || this.state.feature == '')) {
            this.setState({feature: ref.getFeature()});
        }
    };

  //切换面板的回调
  handleTabsChange = (key) => {

    //切换面板时，手动获取对应输入控件的配置参数
    if (key == InputType.INPUT) {
      /** 如果该页面未显示过(实例化)，则这里的ref会为undefined，所以会调用ref的回调方法，在那里获取feature。
          当实例化过一次了，下次就可以调用此方法*/
      if (this.settingInputRef !== undefined) {
        this.setState({ feature: this.settingInputRef.getFeature() });
      }
    } else if (key == InputType.TEXTAREA) {
      if (this.settingTextAreaRef !== undefined) {
        this.setState({ feature: this.settingTextAreaRef.getFeature() });
      }
    } else if (key == InputType.RADIO) {
      if (this.settingRadioRef !== undefined) {
        this.setState({ feature: this.settingRadioRef.getFeature() });
      }
    } else if (key == InputType.SELECT) {
      if (this.settingSelectRef !== undefined) {
        this.setState({ feature: this.settingSelectRef.getFeature() });
      }
    } else if (key == InputType.SWITCH) {
      if (this.settingSwitchRef !== undefined) {
        this.setState({ feature: this.settingSwitchRef.getFeature() });
      }
    } else if (key == InputType.DATEPICKER) {
      if (this.settingDatePickerRef !== undefined) {
        this.setState({ feature: this.settingDatePickerRef.getFeature() });
      }
    } else if (key == InputType.RANGEPICKER) {
      if (this.settingRangePickerRef !== undefined) {
        this.setState({ feature: this.settingRangePickerRef.getFeature() })
      }
    } else if (key == InputType.UPLOAD) {
      if (this.settingUploadRef !== undefined) {
        this.setState({ feature: this.settingUploadRef.getFeature() })
      }
    } else if (key == InputType.TIMEPICKER) {
      if (this.settingTimePickerRef !== undefined) {
        this.setState({ feature: this.settingTimePickerRef.getFeature()})
      }
    } else if (key == InputType.MULTISELECT) {
      if (this.settingMultiSelectRef !== undefined) {
        this.setState({ feature: this.settingMultiSelectRef.getFeature()})
      }
    } else if (key == InputType.NHCASCADER) {
      if (this.settingNHCascaderRef !== undefined) {
        this.setState({ feature: this.settingNHCascaderRef.getFeature()})
      }
    } else if (key == InputType.DATETIMEPICKER) {
      if (this.settingDateTimePickerRef !== undefined) {
        this.setState({ feature: this.settingDateTimePickerRef.getFeature()})
      }
    } else if (key == InputType.INPUTNUMBER) {
      if (this.settingInputNumberRef !== undefined) {
        this.setState({feature: this.settingInputNumberRef.getFeature()});
      }
    } else if (key == InputType.MONTHPICKER) {
        if (this.settingMonthPickerRef !== undefined) {
            this.setState({ feature: this.settingMonthPickerRef.getFeature() });
        }
    } else if (key == InputType.OLDUPLOAD) {
      if (this.settingOldUploadRef !== undefined) {
        this.setState({ feature: this.settingOldUploadRef.getFeature() })
      }
    }
  }

  //子组件状态提升，同步当前设置的参数
  handleInputChange = (feature) => {
    this.setState({
      feature: feature
    });
  }

  //供父组件获取feature
  getFeature = () => {
    return this.state.feature;
  }

  render() {

    let initFeature = {};
    if (this.state.feature !== undefined && this.state.feature != '') {
      try {
        initFeature = JSON.parse(this.state.feature);
      } catch (e) {
        message.error('解析控件配置参数出错！');
      }
    }

    return (
      <div id="div-inputPicker-editPage">
        <Tabs
          defaultActiveKey={this.state.defaultActiveKey}
          tabPosition="left"
          size="small"
          onChange={this.handleTabsChange}
          style={{height:500}}
        >
          <TabPane tab="单行输入框" key={InputType.INPUT}>
            <SettingInput ref={this.saveSettingInputRef}
              initFeature={initFeature.type == InputType.INPUT ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
          <TabPane tab="多行输入框" key={InputType.TEXTAREA}>
            <SettingTextArea ref={this.saveSettingTextAreaRef}
              initFeature={initFeature.type == InputType.TEXTAREA ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
          <TabPane tab="单选下拉选择器" key={InputType.SELECT}>
            <SettingSelect ref={this.saveSettingSelectRef}
              initFeature={initFeature.type == InputType.SELECT ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
          <TabPane tab="多选下拉选择器" key={InputType.MULTISELECT}>
            <SettingMultiSelect ref={this.saveSettingMultiSelectRef}
              initFeature={initFeature.type == InputType.MULTISELECT ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
          <TabPane tab="级联下拉选择器" key={InputType.NHCASCADER}>
            <SettingNHCascader ref={this.saveSettingNHCascaderRef}
              initFeature={initFeature.type == InputType.NHCASCADER ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
          <TabPane tab="开关选择器" key={InputType.SWITCH}>
            <SettingSwitch ref={this.saveSettingSwitchRef}
              initFeature={initFeature.type == InputType.SWITCH ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
          <TabPane tab="单选框" key={InputType.RADIO}>
            <SettingRadio ref={this.saveSettingRadioRef}
              initFeature={initFeature.type == InputType.RADIO ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
          <TabPane tab="日期选择框" key={InputType.DATEPICKER}>
            <SettingDatePicker ref={this.saveSettingDatePickerRef}
              initFeature={initFeature.type == InputType.DATEPICKER ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
            <TabPane tab="月份选择框" key={InputType.MONTHPICKER}>
                <SettingMonthPicker ref={this.saveSettingMonthPickerRef}
                                    initFeature={initFeature.type === InputType.MONTHPICKER ? this.state.feature : null}
                                    onChange={this.handleInputChange}
                />
            </TabPane> 
          <TabPane tab='时间选择框' key={InputType.TIMEPICKER}>
            <SettingTimePicker ref={this.saveSettingTimePickerRef}
              initFeature={initFeature.type == InputType.TIMEPICKER ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
          <TabPane tab='日期时间选择框' key={InputType.DATETIMEPICKER}>
            <SettingDateTimePicker ref={this.saveSettingDateTimePickerRef}
              initFeature={initFeature.type == InputType.DATETIMEPICKER ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane> 
          <TabPane tab='附件上传' key={InputType.OLDUPLOAD} >
            <SettingOldUploadPicker ref={this.saveSettingOldUploadRef}
              initFeature={initFeature.type == InputType.OLDUPLOAD ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
          <TabPane tab='数字输入框' key={InputType.INPUTNUMBER} >
            <SettingInputNumber ref={this.saveSettingInputNumberRef}
              initFeature={initFeature.type == InputType.INPUTNUMBER ? this.state.feature : null}
              onChange={this.handleInputChange}
            />
          </TabPane>
        </Tabs>
      </div>
    )
  }
}
export default EditPage;



// WEBPACK FOOTER //
// ./components/common/NHInputPicker/edit-page.js